// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"223":"6fce5968","868":"ba7084db"}[chunkId] + ".chunk.js";
};